/**
 * Armazenamento local que o core usa (rascunhos, fila de envio): o
 * `localStorage` no navegador e o MMKV no celular cabem aqui (sincronos ou
 * não).
 */
export interface KeyValueStorage {
  getItem(key: string): string | null | Promise<string | null>;
  setItem(key: string, value: string): void | Promise<void>;
  removeItem(key: string): void | Promise<void>;
}

/** Em memória (testes e quando não há armazenamento). */
export function memoryStorage(): KeyValueStorage {
  const data = new Map<string, string>();
  return {
    getItem: (key) => data.get(key) ?? null,
    setItem: (key, value) => {
      data.set(key, value);
    },
    removeItem: (key) => {
      data.delete(key);
    },
  };
}
